import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large SubmitOrder",
    title: "Выдача выбранных заказов",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.submitOrder
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        class: "mt-3",
        "is-invalid": _ctx.state_form$.courier.$error,
        "validation-errors": _ctx.state_form$.courier.$errors,
        value: _ctx.state.courier,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.courier) = $event)),
        placeholder: "Выберите курьера",
        label: "fullName",
        "search-by": "fullName",
        options: _ctx.data_state.couriers.list,
        loading: _ctx.data_state.couriers.is_loading,
        failed: _ctx.data_state.couriers.is_failed,
        "error-text": "При получении списка курьеров произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCouriers(_ctx.data_state.couriers.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCouriers(_ctx.data_state.couriers.pagination.current_page + 1))),
        onSearch: _ctx.searchCourier,
        onOptionBySearch: _ctx.unshiftFindedCourier
      }, null, 8, ["is-invalid", "validation-errors", "value", "options", "loading", "failed", "onSearch", "onOptionBySearch"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}